export default __webpack_public_path__ + "static/media/hand-holding-red-heart-wood-background (1) (1) (1).276fadd0.jpg";